exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:995px){.style-cssmodule-linkSeparator-3IdEM{display:none}}", ""]);

// exports
exports.locals = {
	"linkSeparator": "style-cssmodule-linkSeparator-3IdEM"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./components/templates/AuthenticationLayout/components/ContactLinks/style.cssmodule.css
// module id = 2540
// module chunks = 121